/*
 * @Author: your name
 * @Date: 2020-08-08 17:21:22
 * @LastEditTime: 2020-09-24 15:21:55
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /x-product-workspace/packages/xdap-h5/src/locale/lang/zh-CN/index.js
 */
import common from './common'
import profile from './personal-profile/personal-profile'
import messageCenter from './message-center'
import blank from './blank'
import todoCenter from './todo-center'
import messageRemindModal from './message-remind-modal'

const locale = {
  demo: {
    'hello': '欢迎'
  },
  common,
  profile,
  messageCenter,
  blank,
  todoCenter,
  messageRemindModal
}

export default locale
